import { render, staticRenderFns } from "./AllGamesView.vue?vue&type=template&id=0c1d8b98&scoped=true"
import script from "./AllGamesView.vue?vue&type=script&lang=js"
export * from "./AllGamesView.vue?vue&type=script&lang=js"
import style0 from "./AllGamesView.vue?vue&type=style&index=0&id=0c1d8b98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c1d8b98",
  null
  
)

export default component.exports